import React, { useState, useEffect } from 'react';
import { StyleSheet, View, Image, Text, Dimensions } from 'react-native';


const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

const IMAGES = [
  require('./src/interieur.jpg'),
  require('./src/exterieur.jpg'),
  require('./src/interieur4.PNG'),
];



export function LocalisationPhone() {

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((currentImageIndex + 1) % IMAGES.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [currentImageIndex]);

  const currentImage = IMAGES[currentImageIndex];

  return (
    <View >
      <View style={styles.title}>
        <Text style={styles.textTitle} >Localisation</Text>
      </View>
      <View style={styles.containerFlex}>
        <View style={styles.containerLoca}>
          <Image style={styles.img}
            source={require('./src/localisation.PNG')}
          />
        </View>
        <View style={styles.containerLoca}>
          <Image source={currentImage} style={styles.img} />
        </View>
      </View>
    </View>
  )
};

const styles = StyleSheet.create({
  containerFlex: {
    paddingHorizontal: 15,
    paddingTop: 25,
    paddingBottom: 250,
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',

  },
  containerLoca: {
    marginTop: 10,
    width:'100%',
    height: '100%',
  },
  img: {
    height: '100%',
    width: '100%',
    borderRadius: 10,
  },
  title: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 70,

  },
  textTitle: {
    fontSize: 50,
  }
});


